/**
 * Returns a URL-friendly version of a string.
 * @param str The input string to be slugified.
 * @returns A new string containing the slugified version of the input string.
 */
export const slugify = (str:string) => {
  if (!str) return str;
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/-+/g, '-').replace(/^-|-$/g, '').toLowerCase();
}